import type { KarlAnswerTone, ResolveAnswerTones } from "./types";

export const resolveAnswerTones: ResolveAnswerTones = (answers) => {
  let hasPrimary = false;

  const tones: KarlAnswerTone[] = answers.map((answer) => {
    const tone = answer.tone ?? "default";
    if (tone !== "primary") return tone;
    // A second filled button is two recommendations, which is none.
    if (hasPrimary) return "default";
    hasPrimary = true;
    return "primary";
  });

  if (hasPrimary) return tones;

  // An ask that declares no expectation still gets one filled button: the
  // estimator reads the ladder top-down and must not have to weigh equals.
  const lead = tones.findIndex((tone) => tone !== "quiet");
  if (lead === -1) return tones;

  return tones.map((tone, position) => (position === lead ? "primary" : tone));
};
